import "./baseLayout-style.css";

const BaseLayout = ({ children }) => {
  return <div className="wrapper">{children}</div>;
};

export default BaseLayout;
